;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    dataList: Array,
    filename: String
  },
  methods: {
    download: function download() {
      if (!this.dataList || this.dataList.length < 1) {
        return;
      }

      var name = this.filename || "data.csv";

      var blob = new Blob(["\uFEFF", this.buildCsvString()], {
        type: "text/csv;charset=utf-8;"
      });

      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, name);
        return;
      }

      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");

      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(function () {
        return URL.revokeObjectURL(url);
      }, 1000);
    },
    buildCsvString: function buildCsvString() {
      var _this = this;

      var columnDelimiter = ",";
      var lineDelimiter = "\r\n";
      var cols = (0, _keys2.default)(this.dataList[0]).sort(function (a, b) {
        a = parseInt(a.split(".")[0]) || 0;
        b = parseInt(b.split(".")[0]) || 0;

        return a - b;
      });

      var rows = [cols.map(function (col) {
        return _this.escapeCell(_this.removeOrdering(col));
      })];

      this.dataList.forEach(function (row) {
        rows.push(cols.map(function (col) {
          return _this.escapeCell(row[col]);
        }));
      });

      return rows.map(function (cells) {
        return cells.join(columnDelimiter);
      }).join(lineDelimiter) + lineDelimiter;
    },
    escapeCell: function escapeCell(value) {
      if (value === null || value === undefined) {
        return "";
      }

      var str = String(value);

      return (/[",\r\n]/.test(str) ? '"' + str.replace(/"/g, '""') + '"' : str
      );
    },
    removeOrdering: function removeOrdering(col) {
      var colNum = parseInt(col.split(".")[0]) || null;

      if (colNum) {
        colNum = colNum + ".";
        var index = col.indexOf(colNum);

        col = col.slice(0, index) + col.slice(index + colNum.length);
        return col.trim();
      } else {
        return col;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aa258560", __vue__options__)
  } else {
    hotAPI.reload("data-v-aa258560", __vue__options__)
  }
})()}